<template>
    <div>
        <div v-if="!expenseReportLoaded" class="container">
            <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
        </div>
        <div v-if="expenseReportLoaded" class="container">
            <div class="d-flex flex-column align-items-center">
                <h4>Travel Expense Report</h4>
                <p>Generated at {{currentDate | formatDatetime}}</p>
                <p>{{expenseReport.expenseReportStatusTypeName}}</p>
            </div>
            <div>
                <h4>Trip Profile</h4>
                <div v-if="!tripLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="tripLoaded">
                    <h4 style="font-weight:bold">TripName: {{expenseReport.trip.tripName}}</h4>
                    <div class="mb-4" v-for="dest,destIndex in expenseReport.trip.destinations">
                        <h4 style="font-weight:bold">Destination {{destIndex + 1}}</h4>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Location Type:</label>
                                <p v-if="dest.domestic == 'other'" class="form-control-plaintext">Other US</p>
                                <p v-if="dest.domestic === false" class="form-control-plaintext">Foreign</p>
                                <p v-if="dest.domestic === true" class="form-control-plaintext">Continental US</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label v-if="dest.domestic == 'other'">Work / Event Site:</label>
                                <label v-if="dest.domestic === false">Foreign City Event Site:</label>
                                <label v-if="dest.domestic === true">Work / Event Site:</label>
                                <p v-if="dest.domestic == 'other'" class="form-control-plaintext">{{getLookupValue(usOtherLocations, 'displayName', dest.otherDomesticLocationId)}}</p>
                                <p v-if="dest.domestic === false" class="form-control-plaintext">{{getLookupValue(foreignLocations, 'displayName', dest.foreignLocationId)}}</p>
                                <p v-if="dest.domestic === true" class="form-control-plaintext">{{getLookupValue(domesticLocations, 'displayName', dest.domesticLocationId)}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label>Purpose:</label>
                                <p class="form-control-plaintext">{{dest.purpose}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Start Date:</label>
                                <p class="form-control-plaintext">{{dest.startDate | formatDate}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>End Date:</label>
                                <p class="form-control-plaintext">{{dest.endDate | formatDate}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label>Was there a personal component?</label>
                                <p class="form-control-plaintext">{{dest.personal | yesno}}</p>
                                <ul>
                                    <li v-for="personalDate in dest.personalDates">
                                        {{personalDate.startDate | formatDate}}<span v-if="!personalDate.personalRange"> - {{personalDate.endDate | formatDate}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Did you fly to / from another airport as a consequence of personal travel?</label>
                            <p class="form-control-plaintext">{{expenseReport.trip.additionalAirport | yesno}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Air</h4>
                <div v-if="!airFareLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="airFareLoaded">
                    <div class="mb-4" v-for="ticket,ticketIndex in airFare.airfareTickets">
                        <h4 style="font-weight:bold">Ticket {{ticketIndex + 1}}</h4>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Airline Carrier:</label>
                                <p class="form-control-plaintext">{{getLookupValue(airlineTypes, 'name', ticket.airlineId)}}</p>
                            </div>
                            <div v-if="ticket.airlineId == 9" class="form-group col-sm-6">
                                <label>Foreign Airline Exception:</label>
                                <p class="form-control-plaintext">{{getLookupValue(foreignAirlineReasonTypes, 'displayName', ticket.airfareForeignAirlineReasonTypeId)}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label v-if="tripHasPersonalDay">Business-only Airfare:</label>
                                <label v-if="!tripHasPersonalDay">Ticket Cost:</label>
                                <p class="form-control-plaintext">{{ticket.businessAmount | currency}}</p>
                            </div>
                            <div v-if="tripHasPersonalDay" class="form-group col-sm-6">
                                <label>Actual airfare:</label>
                                <p class="form-control-plaintext">{{ticket.personalAmount | currency}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Was this ticket non-refundable?</label>
                                <p class="form-control-plaintext">{{ticket.isNonRefundable | yesno}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>Non-refundable Exception:</label>
                                <p class="form-control-plaintext">{{getLookupValue(nonRefundableTypes, 'displayName', ticket.nonRefundableTypeId)}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Was this ticket for business/first class?</label>
                                <p class="form-control-plaintext">{{ticket.isFirstClass | yesno}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>Business/First Class Exception:</label>
                                <p class="form-control-plaintext">{{getLookupValue(firstClassTypes, 'displayName', ticket.firstClassTypeId)}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2" v-for="bag,bagIndex in airFare.airfareBaggages">
                        <h4 style="font-weight:bold">Baggage Fee {{bagIndex + 1}}</h4>
                        <div class="form-group col-sm-12">
                            <p class="form-control-plaintext">{{bag.amount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Supporting Remark:</label>
                            <p class="form-control-plaintext">{{airFare.supportingRemark}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Lodging</h4>
                <div v-if="!lodgingLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="lodgingLoaded">
                    <div class="mb-4" v-for="lodge,lodgeIndex in lodges">
                        <h4 style="font-weight:bold">Hotel {{lodgeIndex + 1}}</h4>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label>Hotel Name:</label>
                                <p class="form-control-plaintext">{{lodge.lodgeName}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Check In:</label>
                                <p class="form-control-plaintext">{{lodge.startDate | formatDate}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>Check Out:</label>
                                <p class="form-control-plaintext">{{lodge.endDate | formatDate}}</p>
                            </div>
                        </div>
                        <div v-if="lodge.lodgeDates.length > 0" class="mb-2">
                            List each day out
                            <div class="mb-4" v-for="ld,ldIndex in lodge.lodgeDates">
                                <div class="row">
                                    <div class="form-group col-sm-6">
                                        <label>Day {{ldIndex + 1}}:</label>
                                        <p class="form-control-plaintext">{{ld.date | formatDate}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-sm-6">
                                        <label>Base:</label>
                                        <p class="form-control-plaintext">{{ld.amount | currency}}</p>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <label>Taxes:</label>
                                        <p class="form-control-plaintext">{{ld.tax | currency}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-sm-6">
                                        <label>Adjustment:</label>
                                        <p class="form-control-plaintext">{{ld.adjustment | currency}}</p>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <label>Day Total:</label>
                                        <p class="form-control-plaintext">{{ld.total | currency}}</p>
                                    </div>
                                </div>
                                <div class="mb-2" v-for="ex in ld.exceptions">
                                    <div class="row" v-if="ex.expenseExceptionTypeId == 1">
                                        <div class="form-group col-sm-12">
                                            <label>Actual cost exceeds allowable per diem exception...</label>
                                            <p class="form-control-plaintext">{{getLookupValue(lodgeExceptionTypes, 'text', ex.responseValue)}}</p>
                                        </div>
                                    </div>
                                    <div class="row" v-if="ex.expenseExceptionTypeId == 2">
                                        <div class="form-group col-sm-12">
                                            <label>Because you charged expenses on a personal day exception... (Attachment)</label>
                                        </div>
                                    </div>
                                    <div class="row" v-if="ex.expenseExceptionTypeId == 3">
                                        <div class="form-group col-sm-12">
                                            <label>Per Diem Rate is not valid</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label>Base Sub-Total:</label>
                                    <p class="form-control-plaintext">{{lodge.amountSubTotal | currency}}</p>
                                </div>
                                <div class="form-group col-sm-6">
                                    <label>Taxes Sub-Total:</label>
                                    <p class="form-control-plaintext">{{lodge.taxSubTotal | currency}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label>Sub-Total:</label>
                                    <p class="form-control-plaintext">{{lodge.subTotal | currency}}</p>
                                </div>
                                <div class="form-group col-sm-6">
                                    <label>Adjustment Sub-Total:</label>
                                    <p class="form-control-plaintext">{{lodge.adjustmentSubTotal | currency}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-sm-12">
                                    <label>Total:</label>
                                    <p class="form-control-plaintext">{{lodge.total | currency}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Supporting Remark:</label>
                            <p class="form-control-plaintext">{{lodging.supportingRemark}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Meals</h4>
                <div v-if="!mealsLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="mealsLoaded">
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="w-100 table table-striped">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Breakfast</th>
                                        <th>Lunch</th>
                                        <th>Dinner</th>
                                        <th>Incidentals</th>
                                        <th>Total</th>
                                        <th>Adjusted Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="m in meal.meals">
                                        <tr>
                                            <td>{{m.date | formatDate}}</td>
                                            <td>{{m.breakfast | currency}}</td>
                                            <td>{{m.lunch | currency}}</td>
                                            <td>{{m.dinner | currency}}</td>
                                            <td>{{m.incidentals | currency}}</td>
                                            <td>{{m.total | currency}}</td>
                                            <td><b>{{m.adjustedTotal | currency}}</b></td>
                                        </tr>
                                        <tr v-if="m.breakfastExceptions.length">
                                            <td>Breakfast Exceptions</td>
                                            <td colspan="6">
                                                <div v-for="e in m.breakfastExceptions">
                                                    <div v-if="e.expenseExceptionTypeId == 4">
                                                        <div>Actual cost exceeds allowable per diem. Was this meal pre-arranged as part of a meeting or event?</div>
                                                        <div><b>{{e.responseValue == 'true' ? 'yes' : 'no'}}</b></div>
                                                    </div>
                                                    <div v-if="e.expenseExceptionTypeId == 5">
                                                        <div>Because you charged expenses on a personal day, please provide an explanation.</div>
                                                        <div><b>{{e.responseValue}}</b></div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="m.lunchExceptions.length">
                                            <td>Lunch Exceptions</td>
                                            <td colspan="6">
                                                <div v-for="e in m.lunchExceptions">
                                                    <div v-if="e.expenseExceptionTypeId == 4">
                                                        <div>Actual cost exceeds allowable per diem. Was this meal pre-arranged as part of a meeting or event?</div>
                                                        <div><b>{{e.responseValue | yesno}}</b></div>
                                                    </div>
                                                    <div v-if="e.expenseExceptionTypeId == 5">
                                                        <div>Because you charged expenses on a personal day, please provide an explanation.</div>
                                                        <div><b>{{e.responseValue}}</b></div>
                                                    </div>
                                                    <div v-if="e.expenseExceptionTypeId == 3">
                                                        <div>Per Diem Rate is not valid</div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="m.dinnerExceptions.length">
                                            <td>Dinner Exceptions</td>
                                            <td colspan="6">
                                                <div v-for="e in m.dinnerExceptions">
                                                    <div v-if="e.expenseExceptionTypeId == 4">
                                                        <div>Actual cost exceeds allowable per diem. Was this meal pre-arranged as part of a meeting or event?</div>
                                                        <div><b>{{e.responseValue | yesno}}</b></div>
                                                    </div>
                                                    <div v-if="e.expenseExceptionTypeId == 5">
                                                        <div>Because you charged expenses on a personal day, please provide an explanation.</div>
                                                        <div><b>{{e.responseValue}}</b></div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="m.incidentalsExceptions.length">
                                            <td>Incidental Exceptions</td>
                                            <td colspan="6">
                                                <div v-for="e in m.incidentalsExceptions">
                                                    <div v-if="e.expenseExceptionTypeId == 4">
                                                        <div>Actual cost exceeds allowable per diem. Was this meal pre-arranged as part of a meeting or event?</div>
                                                        <div><b>{{e.responseValue | yesno}}</b></div>
                                                    </div>
                                                    <div v-if="e.expenseExceptionTypeId == 5">
                                                        <div>Because you charged expenses on a personal day, please provide an explanation.</div>
                                                        <div><b>{{e.responseValue}}</b></div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Grand Total:</label>
                            <p class="form-control-plaintext">{{meal.grandTotal | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Supporting Remark:</label>
                            <p class="form-control-plaintext">{{meal.supportingRemark}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Rental Car</h4>
                <div v-if="!rentalLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="rentalLoaded">
                    <div class="mb-4" v-for="(car,carIndex) in rental.rentalCars">
                        <h4 style="font-weight:bold">Rental Car {{carIndex + 1}}</h4>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Rental Company:</label>
                                <p class="form-control-plaintext">{{getLookupValue(rentalCompaniesTypes, 'displayName', car.rentalCompanyId)}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>Reimbursement Amount:</label>
                                <p class="form-control-plaintext">{{car.amount | currency}}</p>
                            </div>
                        </div>
                        <div class="row" v-if="tripHasPersonalDay">
                            <div class="form-group col-sm-6">
                                <label>Are you claiming an amount less than the amount paid?</label>
                                <p class="form-control-plaintext">{{getLookupValue(amountClaimedLessThanPaidReasons, 'displayName', car.amountClaimedLessThanPaidReasonId)}}</p>
                            </div>
                            <div v-if="car.amountClaimedLessThanPaidReasonId == 2" class="form-group col-sm-6">
                                <label>Reason:</label>
                                <p class="form-control-plaintext">{{car.personalDayExplanation}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label>Are you requesting reimbursement for an amount greater than the cost of compact class?</label>
                                <p class="form-control-plaintext">{{car.isMoreThanCompactClass | yesno}}</p>
                            </div>

                        </div>
                        <div class="row" v-if="car.isMoreThanCompactClass">
                            <div class="form-group col-sm-6">
                                <label>Exception:</label>
                                <p class="form-control-plaintext">{{getLookupValue(moreThanCompactClassTypes, 'displayName', car.moreThanCompactClassTypeId)}}</p>
                            </div>
                            <div class="form-group col-sm-6" v-if="car.moreThanCompactClassTypeId == 4">
                                <label>Reason:</label>
                                <p class="form-control-plaintext">{{car.rentalCostExceededExplanation}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Are you requesting reimbursement for insurance?</label>
                                <p class="form-control-plaintext">{{car.isInsuranceExceedsPolicyLimits | yesno}}</p>
                            </div>
                            <div v-if="car.isInsuranceExceedsPolicyLimits" class="form-group col-sm-6">
                                <label>Cost:</label>
                                <p class="form-control-plaintext">{{car.additionalAmount | currency}}</p>
                            </div>
                        </div>
                        <div class="row" v-if="car.isInsuranceExceedsPolicyLimits">
                            <div class="form-group col-sm-6">
                                <label>Reason:</label>
                                <p class="form-control-plaintext">{{car.reimbursementInsuranceExplanation}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2" v-for="fuel,fuelIndex in rental.fuelCosts">
                        <h4 style="font-weight:bold">Fuel Cost {{fuelIndex + 1}}</h4>
                        <div class="form-group col-sm-12">
                            <p class="form-control-plaintext">{{fuel.amount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Supporting Remark:</label>
                            <p class="form-control-plaintext">{{rental.supportingRemark}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Other Section</h4>
                <div v-if="!otherLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="otherLoaded">
                    <h5>Ground Transportation</h5>
                    <div class="row" v-for="gt in groundTransportation.groundTransportations">
                        <div class="form-group col-sm-4">
                            <label>Date:</label>
                            <p class="form-control-plaintext">{{gt.groundTransportationDate | formatDate}}</p>
                        </div>
                        <div class="form-group col-sm-4">
                            <label>Description:</label>
                            <p class="form-control-plaintext">{{getLookupValue(groundTransportationsTypes, 'displayName', gt.groundTransportationTypeId)}}</p>
                        </div>
                        <div class="form-group col-sm-4">
                            <label>Amount:</label>
                            <p class="form-control-plaintext">{{gt.amount | currency}}</p>
                        </div>
                    </div>
                    <h5>POV Mileage</h5>
                    <div class="row" v-for="pov in groundTransportation.personalVehicleMileages">
                        <div class="form-group col-sm-4">
                            <label>Date:</label>
                            <p class="form-control-plaintext">{{pov.mileageDate | formatDate}}</p>
                        </div>
                        <div v-if="pov.isOdemeterReading" class="form-group col-sm-4">
                            <label>Odometer Start:</label>
                            <p class="form-control-plaintext">{{pov.startOdometerReading}}</p>
                        </div>
                        <div v-if="pov.isOdemeterReading" class="form-group col-sm-4">
                            <label>Odometer End:</label>
                            <p class="form-control-plaintext">{{pov.endOdometerReading}}</p>
                        </div>
                        <div v-if="!pov.isOdemeterReading" class="form-group col-sm-4">
                            <label>Map:</label>
                            <p class="form-control-plaintext">{{pov.mileage}}</p>
                        </div>
                    </div>
                    <h5>Other</h5>
                    <div v-for="mc in miscCost.miscCosts">
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Date:</label>
                                <p class="form-control-plaintext">{{mc.miscCostDate | formatDate}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>Amount:</label>
                                <p class="form-control-plaintext">{{mc.amount | currency}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label>Description:</label>
                                <p class="form-control-plaintext">{{getLookupValue(miscCostTypes, 'displayName', mc.miscCostTypeId)}}</p>
                            </div>
                            <div class="form-group col-sm-6">
                                <label>&nbsp;</label>
                                <p class="form-control-plaintext">{{mc.miscCostTypeComment}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label>Supporting Remark:</label>
                            <p class="form-control-plaintext">{{miscCost.supportingRemark}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="!submissionLoaded" class="container">
                    <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-if="submissionLoaded">
                    <h4>Review and Submit</h4>
                    <div class="row">
                        <div class="col-sm-6">
                            <label>Category</label>
                        </div>
                        <div class="col-sm-6">
                            <label>Reimbursement</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Air</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.airfareReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Lodging</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.lodgingReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Meals</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.mealReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Rental Car</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.carRentalReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Ground Transportation</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.groundTransportationReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">POV Mileage</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.personalVehicleMileageReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Misc Costs</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.miscCostReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">Total</p>
                        </div>
                        <div class="col-sm-6">
                            <p class="form-control-plaintext">{{summaryCosts.totalReimbursementAmount | currency}}</p>
                        </div>
                    </div>
                    <div v-if="submission" class="mt-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Project Allocation</label>
                            </div>
                        </div>
                        <div v-for="p in submission.projectAmountAllocations" class="row">
                            <div class="col-sm-6">
                                <p class="form-control-plaintext">{{getLookupValue(projects, 'projectName', p.projectId)}}</p>
                            </div>
                            <div class="col-sm-6">
                                <p v-if="submission.isPercentAmountAllocation" class="form-control-plaintext">{{p.allocationValue}}% ({{parseFloat((p.allocationValue / 100) * summaryCosts.totalReimbursementAmount).toFixed(2)  | currency}})</p>
                                <p v-if="!submission.isPercentAmountAllocation" class="form-control-plaintext">{{p.allocationValue | currency}})</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Was any portion of this trip cancelled that also resulted in forfeited expenditures?</label>
                                <p class="form-control-plaintext">{{submission.hasForfeitedExpenditureCancellation | yesno}}</p>
                            </div>
                            <div class="col-sm-6">
                                <label>Reason:</label>
                                <p class="form-control-plaintext">{{submission.forfeitedExpenditureCancellationComment}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Where possible, were steps taken to minimize cancellation costs?</label>
                                <p class="form-control-plaintext">{{submission.hasMinimizeCosts | yesno}}</p>
                            </div>
                            <div class="col-sm-6">
                                <label>Reason:</label>
                                <p class="form-control-plaintext">{{submission.hasMinimizeCostsComment}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Foreign Currency Conversion</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Foreign Currency Amount ($1 USD)</label>
                            </div>
                            <div class="col-sm-6">
                                <label>Exchange Rate Used</label>
                            </div>
                        </div>
                        <div v-for="fEA in submission.foreignExchangeAmounts" class="row">
                            <div class="col-sm-6">
                                <p class="form-control-plaintext">{{fEA.amount | currency}}</p>
                            </div>
                            <div class="col-sm-6">
                                <p class="form-control-plaintext">{{getCurrencyLookup(fEA.foreignCurrency)}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label>General Comments:</label>
                                <p class="form-control-plaintext">{{submission.generalComment}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
    div {
        font-size: 1.2rem;
    }

    .form-control-plaintext {
        font-weight: bold;
    }
</style>

<script>
    import TripProfileService from '@/services/TripProfileService'
    import ProjectService from '@/services/ProjectService'
    import AirfareService from '@/services/AirfareService'
    import LodgeService from '@/services/LodgeService'
    import CarRentalService from '@/services/CarRentalService'
    import GroundTransportationService from '@/services/GroundTransportationService'
    import MiscCostService from '@/services/MiscCostService'
    import SubmissionService from '@/services/SubmissionService'
    import MealService from '@/services/MealService'
    import DateService from '@/services/DateService'

    export default {
        name: 'travel-expense-report-print',
        components: {
        },
        async created() {
            this.currentDate = new Date();
            if (this.$route.params.erid) {
                this.loading = true;
                this.expenseReportID = this.$route.params.erid;

                this.expenseReport = await TripProfileService.getExpenseReport(this.expenseReportID);
                this.tripHasPersonalDay = this.expenseReport.trip.additionalAirport;
                this.expenseReportLoaded = true;
                this.getTripData();
                this.getAirfareData();
                this.getLodgingData();
                this.getMealsData();
                this.getRentalCarData();
                this.getOtherData();
                this.getSubmissionData();
            }
        },
        data: function () {
            return {
                currentDate: null,
                expenseReportLoaded: false,
                tripLoaded: false,
                airFareLoaded: false,
                lodgingLoaded: false,
                mealsLoaded: false,
                otherLoaded: false,
                rentalLoaded: false,
                submissionLoaded: false,
                expenseReportID: null,
                expenseReport: null,
                reportItemTypes: [],
                projects: [],
                domesticLocations: [],
                foreignLocations: [],
                usOtherLocations: [],
                tripHasPersonalDay: false,
                airFare: null,
                airlineTypes: [],
                foreignAirlineReasonTypes: [],
                nonRefundableTypes: [],
                firstClassTypes: [],
                lodging: null,
                lodges: [],
                lodgeExceptionTypes: [
                    {
                        text: 'None (overage will not be reimbursed)',
                        id: 2
                    },
                    {
                        text: 'Work/Event is at the lodging site',
                        id: 3
                    },
                    {
                        text: 'Director affirms that lodging within per diem was not available within reasonable proximity to work/event site',
                        id: 4
                    },
                    {
                        text: 'Approved by funding source',
                        id: 5
                    },
                    {
                        text: 'No hotels available under reasonable circumstances (up to 200% per diem)',
                        id: 6
                    }
                ],
                mealExceptionTypes: [
                    {
                        text: 'Actual cost exceeds allowable per diem. Was this meal pre-arranged as part of a meeting or event?',
                        id: 4,
                    },
                    {
                        text: "Because you charged expenses on a personal day, please provide an explanation.",
                        id: 5,
                    }
                ],
                rental: null,
                rentalCompaniesTypes: [],
                moreThanCompactClassTypes: [],
                amountClaimedLessThanPaidReasons: [],
                miscCost: {
                    miscCosts: []
                },
                groundTransportation: {
                    groundTransportations: [],
                    personalVehicleMileages: []
                },
                groundTransportationsTypes: [],
                miscCostTypes: [],
                summaryCosts: {},
                submission: null,
                meal: {
                    grandTotal: 0,
                    meals: [],
                    mealDates: [],
                    supportingRemark: null
                }
            }
        },
        computed: {
            totalMiscReportItemAmount() {
                let total = 0;
                if (this.expenseReport != null && this.expenseReport.miscReportItems != null && this.expenseReport.miscReportItems.length > 0) {
                    this.expenseReport.miscReportItems.forEach(function (item) { total = Number(total) + Number(item.amount) })
                }

                return total;
            }
        },
        methods: {
            async getTripData() {
                try {
                    this.domesticLocations = await TripProfileService.getDomesticLocations();
                    this.domesticLocations.forEach((l) => {
                        let address = l.city

                        if (l.zipCode) {
                            address += `, ${l.zipCode}`
                        }

                        if (l.county) {
                            address += `, ${l.county}`
                        }

                        if (l.state) {
                            address += `, ${l.state}`
                        }

                        l.displayName = address;
                    })

                    this.foreignLocations = await TripProfileService.getForeignLocations();
                    this.foreignLocations.forEach((l) => { l.displayName = l.city + ', ' + l.country })

                    this.usOtherLocations = await TripProfileService.getUSTerritoryLocations();
                    this.usOtherLocations.forEach((l) => { l.displayName = l.city + ', ' + l.country })
                    this.tripLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading trip profile."
                    });
                }
            },
            async getAirfareData() {
                try {
                    this.airFare = await AirfareService.getAirfare(this.expenseReportID);
                    this.airlineTypes = await AirfareService.getAirlineTypes();
                    this.foreignAirlineReasonTypes = await AirfareService.getForeignAirlineReasons();
                    this.nonRefundableTypes = await AirfareService.getNonRefundableTypes();
                    this.firstClassTypes = await AirfareService.getFirstClassTypes();
                    this.airFareLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading Airfare."
                    });
                }
            },
            async getLodgingData() {
                try {
                    this.lodging = await LodgeService.getLodges(this.expenseReportID);
                    this.lodges = this.lodging.lodges;
                    this.lodges.forEach((l) => {
                        l.lodgeDates.forEach((d) => {
                            d.total = (Number(d.amount) + Number(d.tax) + Number(d.adjustment)).toFixed(2)
                        });

                        l.amountSubTotal = _.sumBy(l.lodgeDates, d => Number(d.amount));
                        l.taxSubTotal = _.sumBy(l.lodgeDates, d => Number(d.tax));
                        l.subTotal = l.amountSubTotal + l.taxSubTotal;
                        l.adjustmentSubTotal = _.sumBy(l.lodgeDates, d => Number(d.adjustment));
                        l.total = l.subTotal + l.adjustmentSubTotal;

                        // instead of checking for merged exceptions it might be better to do
                        // if merge exception checkbox in lodge was checked
                        // assign the same exception value to all other lodge dates when saving to database
                        if (l.mergeExceptions) {
                            let firstExceptionValue = l.lodgeDates[0].exceptions[0].responseValue
                            l.lodgeDates.forEach((d) => {
                                d.exceptions.forEach((e) => {
                                    e.responseValue = firstExceptionValue;
                                })
                            })
                        }
                    })
                    this.lodgingLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading Lodging."
                    });
                }
            },
            async getMealsData() {
                // meals
                try {
                    this.meal = await MealService.getMeals(this.expenseReportID);
                    this.mapMealsToView();
                    this.calculateMealsGrandTotal();
                    this.mealsLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading Meals."
                    });
                }
            },
            async getRentalCarData() {
                try {
                    this.rental = await CarRentalService.getCarRental(this.expenseReportID);
                    this.rentalCompaniesTypes = await CarRentalService.getRentalCarCompanyTypes();
                    this.moreThanCompactClassTypes = await CarRentalService.getMoreThanCompactClassTypes();
                    this.amountClaimedLessThanPaidReasons = await CarRentalService.getAmountClaimedLessThanPaidReasons();
                    this.rentalLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading Car Rental."
                    });
                }
            },
            async getOtherData() {
                try {
                    this.miscCost = await MiscCostService.getMiscCost(this.expenseReportID);
                    this.miscCostTypes = await MiscCostService.getMiscCostTypes();
                    this.groundTransportation = await GroundTransportationService.getGroundTransportation(this.expenseReportID);
                    this.groundTransportationsTypes = await GroundTransportationService.getGroundTransportationTypes();
                    this.otherLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading Other."
                    });
                }
            },
            async getSubmissionData() {
                try {
                    this.submission = await SubmissionService.getExpenseReportSubmission(this.expenseReportID);

                }
                catch { }

                try {
                    this.summaryCosts = await SubmissionService.getSummaryCosts(this.expenseReportID);
                    this.projects = await ProjectService.getProjects();
                    this.submissionLoaded = true;
                }
                catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: "Error loading Summary."
                    });
                }
            },
            mapMealsToView() {
                this.meal.meals = [];
                this.meal.mealDates.forEach((eM) => {
                    eM.meals = _.orderBy(eM.meals, 'id', 'asc')

                    let day = {
                        date: DateService.normalizeDateTime(eM.date),
                        dayDateID: eM.id,
                        breakfast: eM.meals[0].amount,
                        breakfastAdjusted: eM.meals[0].adjustment,
                        breakfastFirstOrLastDayAdjustment: 0,
                        breakfastOverThreeTimesAdjustment: 0,
                        breakfastID: eM.meals[0].id,
                        breakfastExceptions: eM.meals[0].exceptions || [],//for now
                        lunch: eM.meals[1].amount,
                        lunchAdjusted: eM.meals[1].adjustment,
                        lunchFirstOrLastDayAdjustment: 0,
                        lunchOverThreeTimesAdjustment: 0,
                        lunchID: eM.meals[1].id,
                        lunchExceptions: eM.meals[1].exceptions || [],//for now
                        dinner: eM.meals[2].amount,
                        dinnerAdjusted: eM.meals[2].adjustment,
                        dinnerFirstOrLastDayAdjustment: 0,
                        dinnerOverThreeTimesAdjustment: 0,
                        dinnerID: eM.meals[2].id,
                        dinnerExceptions: eM.meals[2].exceptions || [],//for now
                        incidentals: eM.meals[3].amount,
                        incidentalsAdjusted: eM.meals[3].adjustment,
                        incidentalsOverThreeTimesAdjustment: 0,
                        incidentalsFirstOrLastDayAdjustment: 0,
                        incidentalsID: eM.meals[3].id,
                        incidentalsExceptions: eM.meals[3].exceptions || [],//for now
                        total: 0,//for now
                        adjustedTotal: 0,//for now
                        personalDay: false, //gets set when comparing to reference days
                        firstOrLastDay: false
                    }

                    day.total = Number(day.breakfast) + Number(day.lunch) + Number(day.dinner) + Number(day.incidentals)
                    day.adjustedTotal = (Number(day.breakfast) + Number(day.breakfastAdjusted)) + (Number(day.lunch) + Number(day.lunchAdjusted)) + (Number(day.dinner) + Number(day.dinnerAdjusted)) + (Number(day.incidentals) + Number(day.incidentalsAdjusted))
                    this.meal.meals.push(day);

                })
            },
            calculateMealsGrandTotal() {
                let grandTotal = 0;
                this.meal.meals.forEach(m => {
                    grandTotal = Number(grandTotal) + Number(m.adjustedTotal)
                })

                this.meal.grandTotal = grandTotal;
            },
            subTotalMiscReportItemAmount(item) {
                let total = 0;
                if (item != null && item.projectAmountAllocations != null && item.projectAmountAllocations.length > 0) {
                    item.projectAmountAllocations.forEach(function (paaItem) {
                        total = Number(total) + Number(paaItem.allocationValue)
                    })
                }
                item.amount = total;
                return total;
            },
            getLookupValue(list, nameProperty, id) {
                const item = list.find((i) => i.id == id)
                if (item) {
                    return item[nameProperty];
                }
            },
            getCurrencyLookup(val) {
                const currency = {
                    "AED": "United Arab Emirates Dirham",
                    "AFN": "Afghan Afghani",
                    "ALL": "Albanian Lek",
                    "AMD": "Armenian Dram",
                    "ANG": "Netherlands Antillean Guilder",
                    "AOA": "Angolan Kwanza",
                    "ARS": "Argentine Peso",
                    "AUD": "Australian Dollar",
                    "AWG": "Aruban Florin",
                    "AZN": "Azerbaijani Manat",
                    "BAM": "Bosnia-Herzegovina Convertible Mark",
                    "BBD": "Barbadian Dollar",
                    "BDT": "Bangladeshi Taka",
                    "BGN": "Bulgarian Lev",
                    "BHD": "Bahraini Dinar",
                    "BIF": "Burundian Franc",
                    "BMD": "Bermudan Dollar",
                    "BND": "Brunei Dollar",
                    "BOB": "Bolivian Boliviano",
                    "BRL": "Brazilian Real",
                    "BSD": "Bahamian Dollar",
                    "BTC": "Bitcoin",
                    "BTN": "Bhutanese Ngultrum",
                    "BWP": "Botswanan Pula",
                    "BYN": "Belarusian Ruble",
                    "BZD": "Belize Dollar",
                    "CAD": "Canadian Dollar",
                    "CDF": "Congolese Franc",
                    "CHF": "Swiss Franc",
                    "CLF": "Chilean Unit of Account (UF)",
                    "CLP": "Chilean Peso",
                    "CNH": "Chinese Yuan (Offshore)",
                    "CNY": "Chinese Yuan",
                    "COP": "Colombian Peso",
                    "CRC": "Costa Rican Colón",
                    "CUC": "Cuban Convertible Peso",
                    "CUP": "Cuban Peso",
                    "CVE": "Cape Verdean Escudo",
                    "CZK": "Czech Republic Koruna",
                    "DJF": "Djiboutian Franc",
                    "DKK": "Danish Krone",
                    "DOP": "Dominican Peso",
                    "DZD": "Algerian Dinar",
                    "EGP": "Egyptian Pound",
                    "ERN": "Eritrean Nakfa",
                    "ETB": "Ethiopian Birr",
                    "EUR": "Euro",
                    "FJD": "Fijian Dollar",
                    "FKP": "Falkland Islands Pound",
                    "GBP": "British Pound Sterling",
                    "GEL": "Georgian Lari",
                    "GGP": "Guernsey Pound",
                    "GHS": "Ghanaian Cedi",
                    "GIP": "Gibraltar Pound",
                    "GMD": "Gambian Dalasi",
                    "GNF": "Guinean Franc",
                    "GTQ": "Guatemalan Quetzal",
                    "GYD": "Guyanaese Dollar",
                    "HKD": "Hong Kong Dollar",
                    "HNL": "Honduran Lempira",
                    "HRK": "Croatian Kuna",
                    "HTG": "Haitian Gourde",
                    "HUF": "Hungarian Forint",
                    "IDR": "Indonesian Rupiah",
                    "ILS": "Israeli New Sheqel",
                    "IMP": "Manx pound",
                    "INR": "Indian Rupee",
                    "IQD": "Iraqi Dinar",
                    "IRR": "Iranian Rial",
                    "ISK": "Icelandic Króna",
                    "JEP": "Jersey Pound",
                    "JMD": "Jamaican Dollar",
                    "JOD": "Jordanian Dinar",
                    "JPY": "Japanese Yen",
                    "KES": "Kenyan Shilling",
                    "KGS": "Kyrgystani Som",
                    "KHR": "Cambodian Riel",
                    "KMF": "Comorian Franc",
                    "KPW": "North Korean Won",
                    "KRW": "South Korean Won",
                    "KWD": "Kuwaiti Dinar",
                    "KYD": "Cayman Islands Dollar",
                    "KZT": "Kazakhstani Tenge",
                    "LAK": "Laotian Kip",
                    "LBP": "Lebanese Pound",
                    "LKR": "Sri Lankan Rupee",
                    "LRD": "Liberian Dollar",
                    "LSL": "Lesotho Loti",
                    "LYD": "Libyan Dinar",
                    "MAD": "Moroccan Dirham",
                    "MDL": "Moldovan Leu",
                    "MGA": "Malagasy Ariary",
                    "MKD": "Macedonian Denar",
                    "MMK": "Myanma Kyat",
                    "MNT": "Mongolian Tugrik",
                    "MOP": "Macanese Pataca",
                    "MRO": "Mauritanian Ouguiya (pre-2018)",
                    "MRU": "Mauritanian Ouguiya",
                    "MUR": "Mauritian Rupee",
                    "MVR": "Maldivian Rufiyaa",
                    "MWK": "Malawian Kwacha",
                    "MXN": "Mexican Peso",
                    "MYR": "Malaysian Ringgit",
                    "MZN": "Mozambican Metical",
                    "NAD": "Namibian Dollar",
                    "NGN": "Nigerian Naira",
                    "NIO": "Nicaraguan Córdoba",
                    "NOK": "Norwegian Krone",
                    "NPR": "Nepalese Rupee",
                    "NZD": "New Zealand Dollar",
                    "OMR": "Omani Rial",
                    "PAB": "Panamanian Balboa",
                    "PEN": "Peruvian Nuevo Sol",
                    "PGK": "Papua New Guinean Kina",
                    "PHP": "Philippine Peso",
                    "PKR": "Pakistani Rupee",
                    "PLN": "Polish Zloty",
                    "PYG": "Paraguayan Guarani",
                    "QAR": "Qatari Rial",
                    "RON": "Romanian Leu",
                    "RSD": "Serbian Dinar",
                    "RUB": "Russian Ruble",
                    "RWF": "Rwandan Franc",
                    "SAR": "Saudi Riyal",
                    "SBD": "Solomon Islands Dollar",
                    "SCR": "Seychellois Rupee",
                    "SDG": "Sudanese Pound",
                    "SEK": "Swedish Krona",
                    "SGD": "Singapore Dollar",
                    "SHP": "Saint Helena Pound",
                    "SLL": "Sierra Leonean Leone",
                    "SOS": "Somali Shilling",
                    "SRD": "Surinamese Dollar",
                    "SSP": "South Sudanese Pound",
                    "STD": "São Tomé and Príncipe Dobra (pre-2018)",
                    "STN": "São Tomé and Príncipe Dobra",
                    "SVC": "Salvadoran Colón",
                    "SYP": "Syrian Pound",
                    "SZL": "Swazi Lilangeni",
                    "THB": "Thai Baht",
                    "TJS": "Tajikistani Somoni",
                    "TMT": "Turkmenistani Manat",
                    "TND": "Tunisian Dinar",
                    "TOP": "Tongan Pa'anga",
                    "TRY": "Turkish Lira",
                    "TTD": "Trinidad and Tobago Dollar",
                    "TWD": "New Taiwan Dollar",
                    "TZS": "Tanzanian Shilling",
                    "UAH": "Ukrainian Hryvnia",
                    "UGX": "Ugandan Shilling",
                    "USD": "United States Dollar",
                    "UYU": "Uruguayan Peso",
                    "UZS": "Uzbekistan Som",
                    "VEF": "Venezuelan Bolívar Fuerte",
                    "VND": "Vietnamese Dong",
                    "VUV": "Vanuatu Vatu",
                    "WST": "Samoan Tala",
                    "XAF": "CFA Franc BEAC",
                    "XAG": "Silver Ounce",
                    "XAU": "Gold Ounce",
                    "XCD": "East Caribbean Dollar",
                    "XDR": "Special Drawing Rights",
                    "XOF": "CFA Franc BCEAO",
                    "XPD": "Palladium Ounce",
                    "XPF": "CFP Franc",
                    "XPT": "Platinum Ounce",
                    "YER": "Yemeni Rial",
                    "ZAR": "South African Rand",
                    "ZMW": "Zambian Kwacha",
                    "ZWL": "Zimbabwean Dollar"
                }

                return currency[val];
            }
        }
    }

</script>
